"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
CategoriesListDirective.$inject = ['_categories'];
function CategoriesListDirective(_categories) {
    return {
        scope: {
            breadcrumbs: '=',
            category: '='
        },
        template: require('./views/categories-list.html'),
        link: function (scope, element, attrs, ngModel) {
            scope.title = scope.category != null ? scope.category.name : 'Shop';
            _categories.get().then(function (response) {
                if (scope.category == null) {
                    scope.categories = response.tree;
                }
                else {
                    //find category in tree structure
                    function flattenTree(nodes) {
                        return _.flatMap(nodes || [], function (node) {
                            return [node].concat(flattenTree(node.childs));
                        });
                    }
                    var category = _.find(flattenTree(response.tree), { _id: scope.category._id });
                    scope.categories = category ? category.childs : [];
                }
            });
        }
    };
}
exports.CategoriesListDirective = CategoriesListDirective;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/directives/CategoriesListDirective.js
// module id = 371
// module chunks = 0